import React from 'react';
import PropTypes from 'prop-types';
import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";
import {
    isEmpty,
    extractWorkSheetData,
    getWithExpiry,
    formatDate,
    ExcelDateToDateString
} from "../../../globals/GlobalFunctions";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import axios from 'axios';
import {refreshToken} from "../../../globals/GlobalFunctions";
import Autocomplete from "@mui/material/Autocomplete";
import {GlobalConstants} from "../../../globals/GlobalConstants";
import TextField from "@mui/material/TextField";
import LoadingButton from "@mui/lab/LoadingButton";
import SaveIcon from "@mui/icons-material/Save";
import Stack from "@mui/material/Stack";
import CircularProgress from "@mui/material/CircularProgress";
import Backdrop from "@mui/material/Backdrop";

//Set the type of the props data
export interface Props {
    excelData: any;
    currentDB: string;
}

function BulkGroupImporter({excelData, currentDB}: Props) {
    //console.log(excelData, "DING");
    const [successAlert, setSuccessAlert] = React.useState(false);
    const [errorAlert, setErrorAlert] = React.useState(false);
    const [validationText, setValidationText] = React.useState("");
    const [validationError, setValidationError] = React.useState(false);
    const [loading, setLoading] = React.useState(false);
    const [isLoading, setIsLoading] = React.useState(false);
    const [currentGroup, setCurrentGroup] = React.useState({group_ID: "", name: "", address: "", address2: "",
        admin_COBRA: false, city: "", election_Range: 0, employer_Size: "", first_Division_ID: "00000001", first_division_name: "", first_division_contract_coverage_End: "",
        first_division_contract_coverage_Start: "", first_Division_Network1: {networkID: "", networkDescription: ""}, first_Division_Network1_Priority: "",
        first_Division_Network2: {networkID: "", networkDescription: ""}, first_Division_Network3: {networkID: "", networkDescription: ""}, first_division_original_Date: "",
        first_division_plan_Year_1: "", first_division_plan_Year_2: "", original_Date: "", plan_Year_1_From_Date: "", plan_Year_1_Thru_Date: "", plan_Year_2_From_Date: "",
        plan_Year_2_Thru_Date: "", state: "", zip_Code: "", first_division_plans: [], first_Division_Network2_Priority: "",
        first_Division_Network3_Priority: "", vbasoftware_database: "CoastalAdminTest", vbapi_Token: "", eff_Date: "", network1ID: "", network2ID: "", network3ID: "", federal_ID: "",
        rX_BIN: "", rX_PCN: "", rX_GRP: ""});

    let token = localStorage.getItem('jwt');

    const handleValidationClose = () => {
        setValidationError(false);
        setValidationText("");
    }

    const initialGroupState = {
        group_ID: "",
        name: "",
        address: "",
        address2: "",
        admin_COBRA: false,
        city: "",
        election_Range: 0,
        employer_Size: "",
        first_Division_ID: "00000001",
        first_division_name: "",
        first_division_contract_coverage_End: "",
        first_division_contract_coverage_Start: "",
        first_Division_Network1: {networkID: "", networkDescription: ""},
        first_Division_Network1_Priority: "",
        first_Division_Network2: {networkID: "", networkDescription: ""},
        first_Division_Network2_Priority: "",
        first_Division_Network3: {networkID: "", networkDescription: ""},
        first_Division_Network3_Priority: "",
        first_division_original_Date: "",
        first_division_plan_Year_1: "",
        first_division_plan_Year_2: "",
        original_Date: "",
        plan_Year_1_From_Date: "",
        plan_Year_1_Thru_Date: "",
        plan_Year_2_From_Date: "",
        plan_Year_2_Thru_Date: "",
        state: "",
        zip_Code: "",
        first_division_plans: [],
        vbasoftware_database: "CoastalAdminTest",
        vbapi_Token: "",
        eff_Date: "",
        network1ID: "",
        network2ID: "",
        network3ID: "",
        federal_ID: "",
        rX_BIN: "",
        rX_GRP: "",
        rX_PCN: ""
    }

    const clearGroup = () => {
        //console.log(currentGroup);
        setCurrentGroup({...initialGroupState});
    }

    const importGroups = async (groupArray : any[]) => {
        refreshToken();
        setIsLoading(true);
        groupArray.forEach(g => (g.first_Division_Network1.networkID = g.network1ID) && (g.first_Division_Network2.networkID = g.network2ID) &&
            (g.first_Division_Network3.networkID = g.network3ID))
        const response =
            await axios
                .put(
                    localStorage.getItem('baseURL') + 'group/putList',
                    groupArray,
                    {headers: {'Authorization': `Bearer ${token}`, accept: "*/*", "Content-Type": "application/json"}}
                ).then(() => {
                    setLoading(false);
                    setIsLoading(false);
                    setSuccessAlert(true);
                }).catch((error) => {
                    //console.log(response);
                    setLoading(false);
                    setValidationText(error.response.request.responseText);
                    setValidationError(true);
                    setIsLoading(false);
                });
        //console.log(response);
    }

    try {
        //Check for data and that there is a sheet in the data named Census
        if (!isEmpty(excelData) && excelData.Sheets.Groups !== undefined) {
            //console.log(excelData, "Made it to formatter!");

            //global function to extract the data into a sequential array of cell data values as well as the column and row ranges
            let sheetDataArray = extractWorkSheetData(excelData.Sheets.Groups);

            let rawCellArray: any[] = sheetDataArray[0];

            let columnRange: number = sheetDataArray[1];

            let rowRange: number = sheetDataArray[2];

            let groupArray: any[] = [];

            //console.log(rawCellArray, "Raw Data");

            //we need to find the column index of the values we require so we can grab the data for each row -- THIS IS WHERE COLUMN NAMES ARE SET
            //we add 1 for each for the loop multiplier to account for it being zero based, but later we subtract 1 to account for the very fist row actually starting at zero
            const groupIndexCollection = {
                groupIDIndex: rawCellArray.indexOf('GROUP ID') + 1,
                groupNameIndex: rawCellArray.indexOf('GROUP NAME') + 1,
                originalDateIndex: rawCellArray.indexOf('ORIGINAL DATE') + 1,
                cobraIndex: rawCellArray.indexOf('ADMIN COBRA?') + 1,
                empSizeIndex: rawCellArray.indexOf('EMPLOYER SIZE') + 1,
                firstDivisionIndex: rawCellArray.indexOf('FIRST DIVISION') + 1,
                firstDivisionNameIndex: rawCellArray.indexOf('FIRST DIVISION NAME') + 1,
                firstDivOrigDateIndex: rawCellArray.indexOf('FIRST DIVISION ORIG. DATE') + 1,
                contractStartIndex: rawCellArray.indexOf('CONTRACT START') + 1,
                contractEndIndex: rawCellArray.indexOf('CONTRACT END') + 1,
                planYear1Index: rawCellArray.indexOf('PLAN YEAR 1') + 1,
                planYear1FromIndex: rawCellArray.indexOf('PLAN YEAR 1 FROM') + 1,
                add2Index: rawCellArray.indexOf('Address 2') + 1,
                cityIndex: rawCellArray.indexOf('City') + 1,
                stateIndex: rawCellArray.indexOf('State') + 1,
                zipIndex: rawCellArray.indexOf('Zip') + 1,
                addIndex: rawCellArray.indexOf('Physical Address') + 1,
                planYear1ToIndex: rawCellArray.indexOf('PLAN YEAR 1 TO') + 1,
                planYear2Index: rawCellArray.indexOf('PLAN YEAR 2') + 1,
                planYear2FromIndex: rawCellArray.indexOf('PLAN YEAR 2 FROM') + 1,
                planYear2ToIndex: rawCellArray.indexOf('PLAN YEAR 2 TO') + 1,
                network1Index: rawCellArray.indexOf('NETWORK 1') + 1,
                net1PriorityIndex: rawCellArray.indexOf('NETWORK 1 PRIORITY') + 1,
                network2Index: rawCellArray.indexOf('NETWORK 2') + 1,
                net2PriorityIndex: rawCellArray.indexOf('NETWORK 2 PRIORITY') + 1,
                network3Index: rawCellArray.indexOf('NETWORK 3') + 1,
                net3PriorityIndex: rawCellArray.indexOf('NETWORK 3 PRIORITY') + 1,
                networkEffDateIndex: rawCellArray.indexOf('NETWORK EFF. DATE') + 1,
                plansIndex: rawCellArray.indexOf('PLANS') + 1,
                taxIDIndex: rawCellArray.indexOf('TAX ID') + 1,
                rxBinIndex: rawCellArray.indexOf('RX BIN') + 1,
                rxPcnIndex: rawCellArray.indexOf('RX PCN') + 1,
                rxGrpIndex: rawCellArray.indexOf('RX GRP') + 1,
            }

            if(groupIndexCollection.groupIDIndex > 0 && groupIndexCollection.groupNameIndex > 0 && groupIndexCollection.originalDateIndex > 0 &&
            groupIndexCollection.cobraIndex > 0 && groupIndexCollection.empSizeIndex > 0 && groupIndexCollection.firstDivisionIndex > 0 &&
            groupIndexCollection.firstDivisionNameIndex > 0 && groupIndexCollection.firstDivOrigDateIndex > 0 && groupIndexCollection.contractStartIndex > 0 &&
            groupIndexCollection.contractEndIndex > 0 && groupIndexCollection.planYear1Index > 0 && groupIndexCollection.planYear1FromIndex > 0 &&
            groupIndexCollection.planYear1ToIndex > 0 && groupIndexCollection.network1Index > 0 && groupIndexCollection.addIndex > 0 &&
            groupIndexCollection.planYear1FromIndex > 0 && groupIndexCollection.cityIndex > 0 && groupIndexCollection.zipIndex > 0 &&
            groupIndexCollection.stateIndex > 0 && groupIndexCollection.networkEffDateIndex > 0 && groupIndexCollection.plansIndex) {

                for (let i = 1; i < rowRange; i++) {
                    //for each new member array we skip over the previous groups determined by the column length, removing 1 to account for our zero based index at the beginning
                    let rowMultiplier = columnRange * i - 1;

                    //start with group ID
                    if (groupIndexCollection.groupIDIndex > 0) {
                        currentGroup.group_ID = rawCellArray[(rowMultiplier + groupIndexCollection.groupIDIndex)].toString().toUpperCase();
                    }

                    //Group Name
                    if (groupIndexCollection.groupNameIndex > 0) {
                        currentGroup.name = rawCellArray[(rowMultiplier + groupIndexCollection.groupNameIndex)].toString().toUpperCase();
                    }

                    //Original Date
                    if (groupIndexCollection.originalDateIndex > 0) {
                        let date = rawCellArray[(rowMultiplier + groupIndexCollection.originalDateIndex)].toString();
                        if (date.includes("/")) {
                            date = formatDate(date);
                        } else if (date.length > 0 && date.length < 6) {
                            date = ExcelDateToDateString(date);
                        } else if (date === "117974") {
                            date = "";
                        }
                        if (date.includes("-")) {
                            date = date.substring(5, 7) + "/" + date.substring(8, 10) + "/" + date.substring(0, 4);
                        }
                        else if (date.length > 7) {
                            date = date.substring(4, 6) + "/" + date.substring(6, 8) + "/" + date.substring(0, 4);
                        }
                        currentGroup.original_Date = date.toString().toUpperCase();
                    }

                    //COBRA
                    if (groupIndexCollection.cobraIndex > 0) {
                        if (rawCellArray[(rowMultiplier + groupIndexCollection.cobraIndex)].toString().toUpperCase() === "YES" ||
                            rawCellArray[(rowMultiplier + groupIndexCollection.cobraIndex)].toString().toUpperCase() === "Y" ) {
                            currentGroup.admin_COBRA = true;
                        }
                        else {
                            currentGroup.admin_COBRA = false;
                        }
                    }

                    //Emp Size
                    if (groupIndexCollection.empSizeIndex > 0) {
                        currentGroup.employer_Size = rawCellArray[(rowMultiplier + groupIndexCollection.empSizeIndex)].toString().toUpperCase();
                    }

                    //first div
                    if (groupIndexCollection.firstDivisionIndex > 0) {
                        currentGroup.first_Division_ID = rawCellArray[(rowMultiplier + groupIndexCollection.firstDivisionIndex)].toString().toUpperCase().padStart(8, "0");
                    }

                    //first div name
                    if (groupIndexCollection.firstDivisionNameIndex > 0) {
                        currentGroup.first_division_name = rawCellArray[(rowMultiplier + groupIndexCollection.firstDivisionNameIndex)].toString().toUpperCase();
                    }

                    //FD Original Date
                    if (groupIndexCollection.firstDivOrigDateIndex > 0) {
                        let date = rawCellArray[(rowMultiplier + groupIndexCollection.firstDivOrigDateIndex)].toString();
                        if (date.includes("/")) {
                            date = formatDate(date);
                        } else if (date.length > 0 && date.length < 6) {
                            date = ExcelDateToDateString(date);
                        } else if (date === "117974") {
                            date = "";
                        }
                        if (date.includes("-")) {
                            date = date.substring(5, 7) + "/" + date.substring(8, 10) + "/" + date.substring(0, 4);
                        }
                        else if (date.length > 7) {
                            date = date.substring(4, 6) + "/" + date.substring(6, 8) + "/" + date.substring(0, 4);
                        }
                        currentGroup.first_division_original_Date = date.toString().toUpperCase();
                    }

                    //Contract Start
                    if (groupIndexCollection.contractStartIndex > 0) {
                        let date = rawCellArray[(rowMultiplier + groupIndexCollection.contractStartIndex)].toString();
                        if (date.includes("/")) {
                            date = formatDate(date);
                        } else if (date.length > 0 && date.length < 6) {
                            date = ExcelDateToDateString(date);
                        } else if (date === "117974") {
                            date = "";
                        }
                        if (date.includes("-")) {
                            date = date.substring(5, 7) + "/" + date.substring(8, 10) + "/" + date.substring(0, 4);
                        }
                        else if (date.length > 7) {
                            date = date.substring(4, 6) + "/" + date.substring(6, 8) + "/" + date.substring(0, 4);
                        }
                        currentGroup.first_division_contract_coverage_Start = date.toString().toUpperCase();
                    }

                    //Contract End
                    if (groupIndexCollection.contractEndIndex > 0) {
                        let date = rawCellArray[(rowMultiplier + groupIndexCollection.contractEndIndex)].toString();
                        if (date.includes("/")) {
                            date = formatDate(date);
                        } else if (date.length > 0 && date.length < 7) {
                            date = ExcelDateToDateString(date);
                        }
                        if (date.includes("-")) {
                            date = date.substring(5, 7) + "/" + date.substring(8, 10) + "/" + date.substring(0, 4);
                        }
                        else if (date.length > 7) {
                            date = date.substring(4, 6) + "/" + date.substring(6, 8) + "/" + date.substring(0, 4);
                        }
                        currentGroup.first_division_contract_coverage_End = date.toString().toUpperCase();
                    }

                    //plan year 1
                    if (groupIndexCollection.planYear1Index > 0) {
                        currentGroup.first_division_plan_Year_1 = rawCellArray[(rowMultiplier + groupIndexCollection.planYear1Index)].toString().toUpperCase();
                    }

                    //Plan Year 1 From
                    if (groupIndexCollection.planYear1FromIndex > 0) {
                        let date = rawCellArray[(rowMultiplier + groupIndexCollection.planYear1FromIndex)].toString();
                        if (date.includes("/")) {
                            date = formatDate(date);
                        } else if (date.length > 0 && date.length < 6) {
                            date = ExcelDateToDateString(date);
                        } else if (date === "117974") {
                            date = "";
                        }
                        if (date.includes("-")) {
                            date = date.substring(5, 7) + "/" + date.substring(8, 10) + "/" + date.substring(0, 4);
                        }
                        else if (date.length > 7) {
                            date = date.substring(4, 6) + "/" + date.substring(6, 8) + "/" + date.substring(0, 4);
                        }
                        currentGroup.plan_Year_1_From_Date = date.toString().toUpperCase();
                    }

                    //Plan Year 1 To
                    if (groupIndexCollection.planYear1ToIndex > 0) {
                        let date = rawCellArray[(rowMultiplier + groupIndexCollection.planYear1ToIndex)].toString();
                        if (date.includes("/")) {
                            date = formatDate(date);
                        } else if (date.length > 0 && date.length < 6) {
                            date = ExcelDateToDateString(date);
                        } else if (date === "117974") {
                            date = "";
                        }
                        if (date.includes("-")) {
                            date = date.substring(5, 7) + "/" + date.substring(8, 10) + "/" + date.substring(0, 4);
                        }
                        else if (date.length > 7) {
                            date = date.substring(4, 6) + "/" + date.substring(6, 8) + "/" + date.substring(0, 4);
                        }
                        currentGroup.plan_Year_1_Thru_Date = date.toString().toUpperCase();
                    }

                    //plan year 2
                    if (groupIndexCollection.planYear2Index > 0) {
                        currentGroup.first_division_plan_Year_2 = rawCellArray[(rowMultiplier + groupIndexCollection.planYear2Index)].toString().toUpperCase();
                    }

                    //Plan Year 2 From
                    if (groupIndexCollection.planYear2FromIndex > 0) {
                        let date = rawCellArray[(rowMultiplier + groupIndexCollection.planYear2FromIndex)].toString();
                        if (date.includes("/")) {
                            date = formatDate(date);
                        } else if (date.length > 0 && date.length < 6) {
                            date = ExcelDateToDateString(date);
                        } else if (date === "117974") {
                            date = "";
                        }
                        if (date.includes("-")) {
                            date = date.substring(5, 7) + "/" + date.substring(8, 10) + "/" + date.substring(0, 4);
                        }
                        else if (date.length > 7) {
                            date = date.substring(4, 6) + "/" + date.substring(6, 8) + "/" + date.substring(0, 4);
                        }
                        currentGroup.plan_Year_2_From_Date = date.toString().toUpperCase();
                    }

                    //Plan Year 2 To
                    if (groupIndexCollection.planYear2ToIndex > 0) {
                        let date = rawCellArray[(rowMultiplier + groupIndexCollection.planYear2ToIndex)].toString();
                        if (date.includes("/")) {
                            date = formatDate(date);
                        } else if (date.length > 0 && date.length < 6) {
                            date = ExcelDateToDateString(date);
                        } else if (date === "117974") {
                            date = "";
                        }
                        if (date.includes("-")) {
                            date = date.substring(5, 7) + "/" + date.substring(8, 10) + "/" + date.substring(0, 4);
                        }
                        else if (date.length > 7) {
                            date = date.substring(4, 6) + "/" + date.substring(6, 8) + "/" + date.substring(0, 4);
                        }
                        currentGroup.plan_Year_2_Thru_Date = date.toString().toUpperCase();
                    }

                    //address
                    if (groupIndexCollection.addIndex > 0) {
                        currentGroup.address = rawCellArray[(rowMultiplier + groupIndexCollection.addIndex)].toString().toUpperCase();
                    }

                    //address 2
                    if (groupIndexCollection.add2Index > 0) {
                        currentGroup.address2 = rawCellArray[(rowMultiplier + groupIndexCollection.add2Index)].toString().toUpperCase();
                    }

                    //city
                    if (groupIndexCollection.cityIndex > 0) {
                        currentGroup.city = rawCellArray[(rowMultiplier + groupIndexCollection.cityIndex)].toString().toUpperCase();
                    }

                    //state
                    if (groupIndexCollection.stateIndex > 0) {
                        if(rawCellArray[(rowMultiplier + groupIndexCollection.stateIndex)].toString().toUpperCase().length > 2 &&
                            GlobalConstants.statesWithAbbreviations.has(rawCellArray[(rowMultiplier + groupIndexCollection.stateIndex)].toString().toUpperCase())){
                            currentGroup.state = GlobalConstants.statesWithAbbreviations.get(rawCellArray[(rowMultiplier + groupIndexCollection.stateIndex)].toString().toUpperCase())!;
                        }
                        else {
                            currentGroup.state = rawCellArray[(rowMultiplier + groupIndexCollection.stateIndex)].toString().toUpperCase();
                        }
                    }

                    //zip
                    if (groupIndexCollection.zipIndex > 0) {
                        currentGroup.zip_Code = rawCellArray[(rowMultiplier + groupIndexCollection.zipIndex)].toString().toUpperCase().padStart(5, "0");
                    }

                    //network 1
                    if (groupIndexCollection.network1Index > 0) {
                        currentGroup.first_Division_Network1.networkID = rawCellArray[(rowMultiplier + groupIndexCollection.network1Index)].toString().toUpperCase();
                        currentGroup.network1ID = rawCellArray[(rowMultiplier + groupIndexCollection.network1Index)].toString().toUpperCase();
                    }

                    //network 1 priority
                    if (groupIndexCollection.net1PriorityIndex > 0) {
                        currentGroup.first_Division_Network1_Priority = rawCellArray[(rowMultiplier + groupIndexCollection.net1PriorityIndex)].toString().toUpperCase();
                    }

                    //network 2
                    if (groupIndexCollection.network2Index > 0) {
                        currentGroup.first_Division_Network2.networkID = rawCellArray[(rowMultiplier + groupIndexCollection.network2Index)].toString().toUpperCase();
                        currentGroup.network2ID = rawCellArray[(rowMultiplier + groupIndexCollection.network2Index)].toString().toUpperCase();
                    }

                    //network 2 priority
                    if (groupIndexCollection.net2PriorityIndex > 0) {
                        currentGroup.first_Division_Network2_Priority = rawCellArray[(rowMultiplier + groupIndexCollection.net2PriorityIndex)].toString().toUpperCase();
                    }

                    //network 3
                    if (groupIndexCollection.network3Index > 0) {
                        currentGroup.first_Division_Network3.networkID = rawCellArray[(rowMultiplier + groupIndexCollection.network3Index)].toString().toUpperCase();
                        currentGroup.network3ID = rawCellArray[(rowMultiplier + groupIndexCollection.network3Index)].toString().toUpperCase();
                    }

                    //network 3 priority
                    if (groupIndexCollection.net3PriorityIndex > 0) {
                        currentGroup.first_Division_Network3_Priority = rawCellArray[(rowMultiplier + groupIndexCollection.net3PriorityIndex)].toString().toUpperCase();
                    }

                    //Network eff date
                    if (groupIndexCollection.networkEffDateIndex > 0) {
                        let date = rawCellArray[(rowMultiplier + groupIndexCollection.networkEffDateIndex)].toString();
                        if (date.includes("/")) {
                            date = formatDate(date);
                        } else if (date.length > 0 && date.length < 6) {
                            date = ExcelDateToDateString(date);
                        } else if (date === "117974") {
                            date = "";
                        }
                        if (date.includes("-")) {
                            date = date.substring(5, 7) + "/" + date.substring(8, 10) + "/" + date.substring(0, 4);
                        }
                        else if (date.length > 7) {
                            date = date.substring(4, 6) + "/" + date.substring(6, 8) + "/" + date.substring(0, 4);
                        }
                        currentGroup.eff_Date = date.toString().toUpperCase();
                    }

                    //plans
                    if (groupIndexCollection.plansIndex > 0) {
                        currentGroup.first_division_plans = rawCellArray[(rowMultiplier + groupIndexCollection.plansIndex)].toString().toUpperCase()
                            .replace(/\s/g, '').split(",");
                    }

                    //Federal ID
                    if (groupIndexCollection.taxIDIndex > 0) {
                        currentGroup.federal_ID = rawCellArray[(rowMultiplier + groupIndexCollection.taxIDIndex)].toString().toUpperCase();
                    }

                    //Rx Bin
                    if (groupIndexCollection.rxBinIndex > 0) {
                        currentGroup.rX_BIN = rawCellArray[(rowMultiplier + groupIndexCollection.rxBinIndex)].toString().toUpperCase();
                    }

                    //Rx Pcn
                    if (groupIndexCollection.rxPcnIndex > 0) {
                        currentGroup.rX_PCN = rawCellArray[(rowMultiplier + groupIndexCollection.rxPcnIndex)].toString().toUpperCase();
                    }

                    //Rx Grp
                    if (groupIndexCollection.rxGrpIndex > 0) {
                        currentGroup.rX_GRP = rawCellArray[(rowMultiplier + groupIndexCollection.rxGrpIndex)].toString().toUpperCase();
                    }

                    currentGroup.vbasoftware_database = currentDB;

                    currentGroup.vbapi_Token = getWithExpiry('vbapi_Token');

                    if(currentGroup.group_ID.length > 0){
                        groupArray.push({...currentGroup});
                    }

                    currentGroup.group_ID = initialGroupState.group_ID;
                    currentGroup.name = initialGroupState.name;
                    currentGroup.address = initialGroupState.address;
                    currentGroup.address2 = initialGroupState.address2;
                    currentGroup.admin_COBRA = initialGroupState.admin_COBRA;
                    currentGroup.city = initialGroupState.city;
                    currentGroup.election_Range = initialGroupState.election_Range;
                    currentGroup.employer_Size = initialGroupState.employer_Size;
                    currentGroup.first_Division_ID = initialGroupState.first_Division_ID;
                    currentGroup.first_division_name = initialGroupState.first_division_name;
                    currentGroup.first_division_contract_coverage_End = initialGroupState.first_division_contract_coverage_End;
                    currentGroup.first_division_contract_coverage_Start = initialGroupState.first_division_contract_coverage_Start;
                    currentGroup.first_Division_Network1 = initialGroupState.first_Division_Network1;
                    currentGroup.first_Division_Network1_Priority = initialGroupState.first_Division_Network1_Priority;
                    currentGroup.first_Division_Network2 = initialGroupState.first_Division_Network2;
                    currentGroup.first_Division_Network2_Priority = initialGroupState.first_Division_Network2_Priority;
                    currentGroup.first_Division_Network3 = initialGroupState.first_Division_Network3;
                    currentGroup.first_Division_Network3_Priority = initialGroupState.first_Division_Network3_Priority;
                    currentGroup.first_division_original_Date = initialGroupState.first_division_original_Date;
                    currentGroup.first_division_plan_Year_1 = initialGroupState.first_division_plan_Year_1;
                    currentGroup.first_division_plan_Year_2 = initialGroupState.first_division_plan_Year_2;
                    currentGroup.original_Date = initialGroupState.original_Date;
                    currentGroup.plan_Year_1_From_Date = initialGroupState.plan_Year_1_From_Date;
                    currentGroup.plan_Year_1_Thru_Date = initialGroupState.plan_Year_1_Thru_Date;
                    currentGroup.plan_Year_2_From_Date = initialGroupState.plan_Year_2_From_Date;
                    currentGroup.plan_Year_2_Thru_Date = initialGroupState.plan_Year_2_Thru_Date;
                    currentGroup.state = initialGroupState.state;
                    currentGroup.zip_Code = initialGroupState.zip_Code;
                    currentGroup.first_division_plans = initialGroupState.first_division_plans;
                    currentGroup.eff_Date = initialGroupState.eff_Date;
                    currentGroup.network1ID = initialGroupState.network1ID;
                    currentGroup.network2ID = initialGroupState.network2ID;
                    currentGroup.network3ID = initialGroupState.network3ID;
                    currentGroup.federal_ID = initialGroupState.federal_ID;
                    currentGroup.rX_BIN = initialGroupState.rX_BIN;
                    currentGroup.rX_PCN = initialGroupState.rX_PCN;
                    currentGroup.rX_GRP = initialGroupState.rX_GRP;

                    clearGroup();
                }


                importGroups(groupArray);

                excelData.Sheets.Groups = undefined;
            }
            else {
                setValidationText("Group ID, name, address info, dates, plan year 1, network 1, contract, cobra, employer size, and plans are required.");
                setValidationError(true);
            }

        }
    }
    catch(e) {
        console.log("ERROR", e);

        setErrorAlert(true);
        //clear it out after errors in case of rerendering otherwise the error spams will continue until morale improves
        excelData.Sheets.Groups = undefined;
    }
    return (
        <div>
            {successAlert ? <Alert className="groupAlertStyles" severity='success' onClose={() => setSuccessAlert(false)} variant="filled">
                <AlertTitle>Success!</AlertTitle>
                Group Import Complete!
            </Alert> : <></> }
            {errorAlert ? <Alert className="groupAlertStyles" severity='error' onClose={() => setErrorAlert(false)} variant="filled">
                <AlertTitle>Error!</AlertTitle>
                There was an error with this file!
            </Alert> : <></> }
            <Dialog
                open={validationError}
                onClose={handleValidationClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description">
                <DialogTitle id="alert-dialog-title">
                    {"Validation Error"}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        {validationText}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleValidationClose}>OK</Button>
                </DialogActions>
            </Dialog>
            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={isLoading}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
        </div>
    );
}

export default React.memo(BulkGroupImporter)

BulkGroupImporter.propTypes = {
    excelData: PropTypes.object.isRequired
};